import React from "react";
import {hscLogo, striveLogo} from "./consts/consts";

const cloneDeep = require('lodash.clonedeep');

export function convertPhoneNumber(phone) {
    if (!phone) {
        return '';
    }
    const p = phone.split(/[()\- ]/g);
    return `${p[1]}.${p[3]}.${p[4]}`
}

export function addCommasToNumberAsString(string) {
    if (!string) {
        return '';
    }
    return string.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}

export function addCommasToNumber(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// data is array of objects
export function calculateTotalColumn(data, key, count = false) {
    return data.reduce((accumulator, currentValue) => {
        let value;
        if (count) {
            value = 1;
        } else {
            value = typeof currentValue[key] === 'string' ? parseFloat(currentValue[key]) : currentValue[key];
        }
        return accumulator + value;
    }, 0);
}

export function formatPhoneNumber(value) {
    if (!value) return value;
    const currentValue = value.replace(/[^\d]/g, '');
    const cvLength = currentValue.length;
    if (cvLength < 4) return currentValue || '';
    if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
}

export function formatNumber(value, isPrice, decimals) {
    if (!value) return value;
    let currentValue = value;
    if (typeof value !== 'string') currentValue = currentValue.toString();
    currentValue = currentValue.replace(/[^\d|.]/g, '');
    if (decimals) return parseFloat(currentValue).toLocaleString(undefined, {maximumFractionDigits: decimals, minimumFractionDigits: decimals});
    if (isPrice) return addCommasToNumberAsString(currentValue);
    return currentValue;
}

export function formatDate(value) {
    if (!value) return value;
    return value.replace(/[^\d|/]/g, '');
}

export function formatAgentPercent(value) {
    if (!value) return value;
    const number = value.split('.');
    const decimals = number[1] ? number[1].length : null;
    if (decimals && decimals > 15) return value.slice(0, -1);
    return value;
}

export function capitalize(string) {
    if (!string) {
        return '';
    }
    return string[0].toUpperCase() + string.slice(1);
}

// separated by comma
export function capitalizeAll(string) {
    if (!string) {
        return '';
    }
    let array = string.split(',');
    array = array.map(el => capitalize(el));
    return array.join(', ');
}

export function formatName(data, key = '') {
    if (data[`${key}FIRST_NAME`] && data[`${key}LAST_NAME`])
        return `${data[`${key}FIRST_NAME`]} ${data[`${key}LAST_NAME`]}`;
    else {
        if (data[`${key}FIRST_NAME`]) return data[`${key}FIRST_NAME`];
        if (data[`${key}LAST_NAME`]) return data[`${key}LAST_NAME`];
        if (data[`${key}COMPANY_NAME`]) return data[`${key}COMPANY_NAME`];
    }
    return null;
}

export function formatType(type) {
    if (!type)
        return null;
    if (type.includes('STNL') && type.includes('MT') && type.includes('Other'))
        return 'Single-Tenant, Other, Multi-Tenant';
    if (type.includes('STNL') && type.includes('MT'))
        return 'Single-Tenant, Multi-Tenant';
    if (type.includes('STNL') && type.includes('Other'))
        return 'Single-Tenant, Other';
    if (type.includes('MT') && type.includes('Other'))
        return 'Other, Multi-Tenant';
    if (type.includes('STNL'))
        return 'Single-Tenant';
    if (type.includes('MT'))
        return 'Multi-Tenant';
    if (type.includes('Other'))
        return 'Other';
    return null;
}

export function addSpaceAfterComma(string) {
    if (!string) return '';
    let result = cloneDeep(string);
    result = result.replace(/,/g, ', ');
    return result;
}

export function percent(value, withDecimals = true) {
    if (value === undefined || value === null || value === '') return '';
    if (withDecimals) return Number(value).toFixed(2)+'%';
    return parseInt(value)+'%';
}

export function formatPropertyName(name, city, state) {
    if (city && state) return `${name} - ${city}, ${state}`;
    if (city) return `${name} - ${city}`;
    if (state) return `${name} - ${state}`;
    return name;
}

// array of objects
export function sortArray(array, key, desc = false) {
    const sortedArray = cloneDeep(array);
    if (key) {
        if (desc) {
            sortedArray.sort((a, b) => (a[key] > b[key]) ? -1 : 1);
        } else {
            sortedArray.sort((a, b) => (a[key] < b[key]) ? -1 : 1);
        }
    } else {
        if (desc) {
            sortedArray.sort((a, b) => (a > b) ? -1 : 1);
        } else {
            sortedArray.sort((a, b) => (a < b) ? -1 : 1);
        }
    }
    return sortedArray;
}

export function renderPrintFooter(isPrint, isHSC = false) {
    if (!isPrint) {
        return null;
    }
    return (
        <div className={`print-footer ${isHSC ? 'hsc' : ''}`}>
            <div className='logo'>
                <img src={arc.path.media + (isHSC ? hscLogo : striveLogo)} alt=''/>
            </div>
            {
                isHSC ? '(469) 998-7200 | highstcapital.com' : '(469) 844-8880 | strivere.com'
            }
        </div>
    )
}

export function getWeeks(startDate, endDate) {
    const dayToMs = 1000 * 60 * 60 * 24;
    const days = (endDate - startDate) / dayToMs;
    return Math.floor((days + startDate.getDay()+1) / 7);
}

// for financials tenants
export function findTenantRow(rows, valueKey, value) {
    const keys = Object.keys(rows);
    for (let index = 0; index < keys.length; index++) {
        if (rows[keys[index]].valueCells[valueKey].value === value) return rows[keys[index]];
    }
}

export function formatPipelineTitle(value) {
    if (!value) return;
    let title = value.split('-');
    if (!title[1]) return title[0][0].toUpperCase()+title[0].slice(1);
    return `${title[0][0].toUpperCase()+title[0].slice(1)} ${title[1].toUpperCase()}`;
}